angular.module("app").controller("BrowseFromServerWithPaginationModalController", [
  '$scope',
  '$uibModalInstance',
  'preloadedImages',
  'logger',
  'pagination',
  'mediaService',
  'errorHandler',
  function ($scope, $modalInstance, preloadedImages, logger, pagination, mediaService, errorHandler) {

    $scope.images = preloadedImages.items;
    $scope.pagination = pagination.init(function () {$scope.updateList();}, preloadedImages.total_count, 10);

    $scope.ok = function () {
      if (!$scope.imageToUse) {
        logger.logError("global.pleaseSelectImage");
        return;
      }
      $modalInstance.close([$scope.imageToUse]);
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.useImage = function (image) {
      $scope.imageToUse = angular.copy(image);
    };


    $scope.getImageStyles = function (image) {
      var styles = {};
      styles["max-width"] = '100px';
      styles["max-height"] = '100px';
      styles["min-width"] = '100px';
      styles["min-height"] = '100px';
      styles["background-size"] = 'contain';
      styles["background-repeat"] = 'no-repeat';
      styles["background-position"] = '50% 0';
      styles["overflow"] = 'hidden';
      styles["display"] = 'inline-block';
      styles["background-image"] = "url('" + image.fileUrl + "')";
      return styles
    };

    $scope.updateList = function updateList() {
        var requestOptions = {
          limit: $scope.pagination.limit,
          current_page: $scope.pagination.page
        };
        mediaService.getImageList(requestOptions).then(
            function (response) {
              if (response.status === "ok") {
                $scope.images = angular.copy(response.items);
                $scope.pagination.totalItems = response.total_count;
              } else {
                errorHandler(response.message);
                return [];
              }
            }
        )
    };

  }
]);
